import { WebSocketProvider } from './context/notifications-web-socket-context';
import { NotificationMessages } from './notification-messages';
import { REACT_APP_NOTIFICATION_URL } from 'config';
import { useAuth } from 'features/auth/contexts/auth';

export { NewNotificationModal } from './modals/new-notification/modal';
export { NotificationWidget } from './notification-widget';

export const NotificationMessagesWrapper = () => {
  const { auth } = useAuth();

  if (!auth?.token) return null;

  return (
    <WebSocketProvider url={`${REACT_APP_NOTIFICATION_URL}/notification-socket?access_token=${auth?.token}`}>
      <NotificationMessages onClose={() => null} />
    </WebSocketProvider>
  );
};
